"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _checkProps = _interopRequireDefault(require("../utils/checkProps"));
var CTA = function CTA(_ref) {
  var ctaStyle = _ref.ctaStyle,
    url = _ref.url,
    label = _ref.label,
    openNewTab = _ref.openNewTab,
    handleClick = _ref.handleClick;
  if (!(0, _checkProps["default"])(ctaStyle) || !(0, _checkProps["default"])(url) || !(0, _checkProps["default"])(label)) {
    return /*#__PURE__*/_react["default"].createElement("a", {
      className: ctaStyle,
      href: url,
      target: openNewTab === true ? '_blank' : '_self',
      onClick: function onClick(e) {
        return handleClick && handleClick(e);
      },
      rel: "noreferrer"
    }, label);
  }
  return null;
};
var _default = CTA;
exports["default"] = _default;